import { Adapter as n } from "../../../../adapter.js";
import { TicketHistoryRefundModel as r } from "./ticketHistoryRefund.model.js";
class o extends n {
  adapt(e) {
    return new r({
      status: e.status,
      timestamp: new Date(e.timestamp * 1e3),
      amount: e.amount,
      currency: e.currency,
      reason: e.reason,
      description: e.description,
      payRefundId: e.pay_refund_id,
      payRefundBalanceTxId: e.pay_refund_balance_tx_id,
      feeTransactionId: e.fee_transaction_id
    });
  }
  serialize(e) {
  }
}
export {
  o as TicketHistoryRefundAdapter
};
//# sourceMappingURL=ticketHistoryRefund.adapter.js.map
